require('../es');
require('../web');
var path = require('../internals/path');

module.exports = path;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/stable/index.js
// module id = 620
// module chunks = 0